import { useEffect } from 'react'
import LoginForm from 'components/LoginForm'
import { selectLoggedIn, selectLogin } from 'selectors/auth'
import { Grid, Row, Col } from 'components/utils/Grid'
import { useAppSelector } from 'store/hooks'

const Login = () => {
  const { loggedIn } = useAppSelector(selectLoggedIn)
  const { login } = useAppSelector(selectLogin)
  const returnUrl = login?.returnUrl

  useEffect(() => {
    if (loggedIn) {
      window.location.href = returnUrl || '/graph'
    }
  }, [loggedIn, returnUrl])

  return (
    <Grid>
      <Row>
        {loggedIn ? <div /> : null}
        <Col sm={5} smPush={1}>
          <h2>Login</h2>
          <LoginForm />
        </Col>
      </Row>
    </Grid>
  )
}

export default Login
